var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/utility/Providers/index.tsx";
import React from 'react';
import { ParallaxProvider, config } from '@adc/parallax-component-library';
import i18next from 'i18next';
import { useTheme as useThemeName } from 'Hooks';
import { store } from 'Utilities/store';
const Providers = ({
  children
}) => {
  const {
    theme: themeName
  } = useThemeName();
  const defaultTheme = themeName.endsWith('Dark') ? 'dark' : 'light';
  const locale = store.getState().env.phoneLanguage;
  const dir = i18next.dir(locale);
  return /*#__PURE__*/React.createElement(ParallaxProvider, {
    config: config,
    locale: locale,
    dir: dir,
    defaultTheme: defaultTheme,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 5
    }
  }, children);
};
export { Providers };